<template>

  <header>
    お知らせ
    <div class="h-left">
      <a @click="$router.push({name: 'notification'})"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
  </header>
  <div id="wrap">
    <div class="clearfix">
      <p class="real-day01">{{ noticeDetail ? noticeDetail.title : '' }}</p>
      <p class="real-day02">{{ p_at }}</p>
    </div>
    <div class="txt-area">
      <div>
        <p>{{ noticeDetail ? noticeDetail.content : ''}}</p>
        <img v-if="noticeDetail && noticeDetail.image" :src="getImageUrl(noticeDetail.image)"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import mixin from "@/mixin"
export default {
  mixins: [mixin],
  data: () => ({
    noticeDetail: null
  }),
  mounted() {
    this.getNoticeDetail()
    this.$store.dispatch("layout/setFooter", false)
  },
  computed: {
    ...mapGetters(["defaultToken", "userDetail"]),
    type() {
      return this.$route.query.type
    },
    id() {
      return this.$route.query.id // Notice id
    },
    nd_id() {
      return this.$route.query.nd_id // Notice done id
    },
    ss_id() {
      return this.$route.query.ss_id // Schedule send id
    },
    p_at() {
      return this.$route.query.p_at // posted at
    },
  },
  methods: {
    getNoticeDetail() {
      let params = {
        type: this.type,
        notice_id: this.id,
        notice_done_id: this.nd_id,
        user_id: this.userDetail.id,
        token: this.defaultToken,
      };

      if (this.type == 'notice' && this.ss_id != '') {
        params['schedule_send_id'] = this.ss_id;
      }

      this.$store.dispatch("profile/getNoticeDetail", params).then(data => {
        this.noticeDetail = data.notice
      }).catch(err => {
        console.log(err)
      })
    }
  }
};
</script>